import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import { useTheme } from '../context/ThemeContext';

export default function Login() {
  const { user, loginWithGoogle, loading } = useAuth();
  const { toggle, isDark } = useTheme();
  const navigate = useNavigate();

  useEffect(() => { if (user) navigate('/dashboard'); }, [user, navigate]);

  async function handleLogin() {
    try { await loginWithGoogle(); }
    catch (err) { alert('Login failed: ' + err.message); }
  }

  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <div className="logo-mark">IP</div>
          <span className="logo-text">IntegratePulse</span>
          <button
            onClick={toggle}
            style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-3)', padding: 6 }}
          >
            {isDark ? (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.2"/><path d="M8 1.5v1M8 13.5v1M1.5 8h1M13.5 8h1M3.4 3.4l.7.7M11.9 11.9l.7.7M11.9 3.4l-.7.7M3.4 11.9l-.7.7" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/></svg>
            ) : (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13.5 8.5A5.5 5.5 0 017.5 2.5a5.5 5.5 0 100 11 5.5 5.5 0 006-5z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/></svg>
            )}
          </button>
        </div>

        <h1 className="login-title">
          Monitor every<br/>
          <span>integration</span> — live.
        </h1>
        <p className="login-sub">
          Real-time health monitoring for your APIs, databases, ERP systems, and AI endpoints. 
          Know the moment something breaks — before your customers do.
        </p>

        <button className="google-btn" onClick={handleLogin}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/>
            <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853"/>
            <path d="M3.964 10.707A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.039l3.007-2.332z" fill="#FBBC05"/>
            <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.961L3.964 7.293C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
          </svg>
          Continue with Google
        </button>

        <div className="login-features">
          <div className="login-feature"><div className="feature-dot green" /><span>Monitor APIs, databases, ERP systems, and AI endpoints</span></div>
          <div className="login-feature"><div className="feature-dot amber" /><span>AI-powered predictive alerts before failures happen</span></div>
          <div className="login-feature"><div className="feature-dot accent" /><span>Public status page for your customers</span></div>
        </div>

        <p className="login-footer">Free for up to 3 integrations. No credit card required.</p>
      </div>

      <div className="login-visual">
        <div className="visual-card">
          <div className="visual-header">
            <div className="visual-dot red" /><div className="visual-dot amber" /><div className="visual-dot green-dot" />
            <span className="visual-title">integratepulse — dashboard</span>
          </div>
          <div className="mini-stats">
            <div class="mini-stat"><div className="mini-stat-val green-text">98.7%</div><div className="mini-stat-label">Uptime</div></div>
            <div className="mini-stat"><div className="mini-stat-val">243ms</div><div className="mini-stat-label">Response</div></div>
            <div className="mini-stat"><div className="mini-stat-val amber-text">1</div><div className="mini-stat-label">Alerts</div></div>
          </div>
          <div className="mini-integrations">
            {[
              { name: 'Salesforce CRM API', status: 'healthy', ms: '187ms' },
              { name: 'SAP ERP Connector', status: 'healthy', ms: '342ms' },
              { name: 'OpenAI GPT-4 API', status: 'slow', ms: '4.2s' },
              { name: 'MySQL Production', status: 'healthy', ms: '89ms' },
              { name: 'Legacy FTP Server', status: 'down', ms: 'timeout' },
            ].map(item => (
              <div key={item.name} className="mini-row">
                <div className={`status-dot ${item.status}`} />
                <span className="mini-name">{item.name}</span>
                <span className="mini-ms">{item.ms}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
